<template>
  <div id="ManagementDetails">
    <BreadCrumb :items="breadcrumbItems" />

    <v-card elevation="1" class="pt-5 mt-1" :loading="loading">
      <div class="header d-flex justify-space-between pr-1 align-center">
        <h1>Em dia</h1>
      </div>

      <div class="mt20"></div>
      <div>
        <v-row class="ma-2 ml-2" style="justify-content: center">
          <div v-for="index in 6" :key="index" class="mx-2 delivery-card">
            <delivery-card />
          </div>
        </v-row>
      </div>

      <div class="mt60"></div>
      <div class="d-flex justify-space-between">
        <v-pagination
          v-model="page"
          length="1"
          total-visible="6"
        ></v-pagination>
      </div>
    </v-card>
  </div>
</template>

<script>
import BreadCrumb from "../../../components/BreadCrumb.vue";
import DeliveryCard from "../../../components/Management/DeliveryCard.vue";
export default {
  name: "ManagementDetails",
  components: {
    BreadCrumb,
    DeliveryCard,
  },
  data: () => ({
    breadcrumbItems: [
      {
        text: "Início",
        disabled: false,
        to: "/start",
      },
      {
        text: "Embarques",
        disabled: false,
        to: "/shipments",
        exact: true,
      },
      {
        text: "Gestão a Vista",
        disabled: false,
        to: "/shipments/management",
        exact: true,
      },
      {
        text: "Detalhes",
        disabled: true,
      },
    ],
    loading: false,
    page: 1,
  }),
};
</script>

<style>
.header h1 {
  padding-left: 10px;
}
.delivery-card {
  width: 31%;
  max-height: 30%;
}
</style>
